export default __webpack_public_path__ + "static/gallery-art-photography-c02bf429d613abace64d3a8a7a4710dc.jpg";